import { render } from "./slideAutoText.vue?vue&type=template&id=5420e632&scoped=true"
import script from "./slideAutoText.vue?vue&type=script&lang=js"
export * from "./slideAutoText.vue?vue&type=script&lang=js"

import "./slideAutoText.vue?vue&type=style&index=0&id=5420e632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5420e632"]])

export default __exports__